export default __webpack_public_path__ + "static/media/benzinga.4326845d.svg";